const MONTHS = [
  "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
  "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre",
];

// Converte "2024-09-24" in "24 settembre 2024". Se il formato non è ISO, restituisce il valore originale.
export function formatDateIt(value) {
  if (!value) return "";
  const m = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return String(value);
  const [, y, mo, d] = m;
  const month = MONTHS[parseInt(mo, 10) - 1];
  if (!month) return String(value);
  return `${parseInt(d, 10)} ${month} ${y}`;
}
